import { useState, useEffect } from 'react';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrollPct, setScrollPct] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setScrollPct(docHeight > 0 ? Math.min(100, (window.scrollY / docHeight) * 100) : 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div
        className="navbar__progress"
        style={{ '--scroll-pct': `${scrollPct}%` }}
        aria-hidden="true"
      />
      <div className="container navbar__inner">
        <a href="/" className="navbar__logo">
          <img src="/images/evolify_logo.png" alt="Evo" className="navbar__logo-img" />
          <img src="/images/evolify-welcome-2.png" alt="Evolify" className="navbar__logo-wordmark" />
        </a>

        <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
          <li><a href="#fonctionnement" onClick={() => setMenuOpen(false)}>Comment ça marche</a></li>
          <li><a href="#fonctionnalites" onClick={() => setMenuOpen(false)}>Fonctionnalités</a></li>
          <li><a href="#philosophie" onClick={() => setMenuOpen(false)}>Notre approche</a></li>
          <li><a href="#temoignages" onClick={() => setMenuOpen(false)}>Témoignages</a></li>
          <li><a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a></li>
        </ul>

        <div className="navbar__actions">
          <a href="#contact" className="btn-primary navbar__cta">Rejoindre la bêta</a>
          <button
            className={`navbar__burger ${menuOpen ? 'navbar__burger--open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </div>
    </nav>
  );
}
